export default "__VITE_ASSET__1ae0d13d__"